/**
 * Footer legal documents, transcribed from the source Word files.
 * Block types: 'h' (heading), 'p' (paragraph), 'ul' (bullet list).
 */
export const legalDocs = [
  {
    id: 'terms',
    label: 'Terms & Conditions',
    blocks: [
      { t: 'p', x: 'Effective Date: 27 July 2026' },
      { t: 'p', x: 'Operator: MZ Energy Solutions, Ontario, Canada' },
      { t: 'p', x: 'LNG School is the educational platform owned and operated by MZ Energy Solutions ("LNG School", "we", "our", or "us").' },
      { t: 'p', x: 'These Terms & Conditions ("Terms") constitute a legally binding agreement between MZ Energy Solutions and every person ("you", "your", or "Participant") who visits the LNG School website, enrols in any LNG School program, or purchases any of our products or services.' },
      { t: 'p', x: 'By accessing our website or purchasing any program or service, you acknowledge that you have read, understood, and agree to be bound by these Terms.' },
      { t: 'h', x: '1. About LNG School' },
      { t: 'p', x: 'LNG School provides professional education, coaching, and career development services for individuals working in, or seeking employment within, the liquefied natural gas (LNG) industry.' },
      { t: 'p', x: 'Depending on the program purchased, our services may include:' },
      { t: 'ul', items: [
        'Live online cohort programs',
        'Technical LNG education',
        'Career coaching',
        'Interview preparation',
        'CV and LinkedIn reviews',
        'Practical simulator demonstrations',
        'Digital learning resources',
        'Recorded sessions',
        'Student communities',
        'Workshops',
        'Future memberships and additional educational services',
      ] },
      { t: 'p', x: 'The specific features, duration, and content of each program are described on the applicable sales page.' },
      { t: 'h', x: '2. Eligibility' },
      { t: 'p', x: 'By enrolling, you confirm that:' },
      { t: 'ul', items: [
        'you are at least 18 years of age;',
        'the information you provide is accurate and complete;',
        'you have the legal capacity to enter into this agreement; and',
        'you will comply with these Terms throughout your participation.',
      ] },
      { t: 'h', x: '3. Program Delivery' },
      { t: 'p', x: 'We continually improve our programs to provide the highest quality learning experience.' },
      { t: 'p', x: 'Accordingly, we may update course materials, instructors, guest speakers, schedules, learning platforms, or delivery methods where reasonably necessary, provided that the overall educational value of the program is not materially reduced.' },
      { t: 'h', x: '4. Enrolment and Payment' },
      { t: 'p', x: 'Your enrolment is confirmed once your registration has been accepted and payment has been successfully processed.' },
      { t: 'p', x: 'Payments may be securely processed through trusted third-party payment providers, including Stripe and PayPal.' },
      { t: 'p', x: 'Where instalment plans are offered, you agree to pay the full program fee according to the selected payment schedule.' },
      { t: 'p', x: 'Failure to make scheduled payments may result in suspension of access until outstanding amounts have been paid.' },
      { t: 'h', x: '5. Access to Programs' },
      { t: 'p', x: 'Unless otherwise stated:' },
      { t: 'ul', items: [
        'access is granted solely to the registered participant;',
        'accounts may not be shared or transferred;',
        'access periods vary according to the program purchased.',
      ] },
      { t: 'p', x: 'Upon expiration of the applicable access period, access to program materials may be removed unless otherwise stated.' },
      { t: 'h', x: '6. Student Responsibilities' },
      { t: 'p', x: 'Participants are expected to maintain a respectful and professional learning environment.' },
      { t: 'p', x: 'You agree to:' },
      { t: 'ul', items: [
        'participate professionally;',
        'complete required learning activities;',
        'respect other participants;',
        'keep your login credentials confidential;',
        'comply with applicable laws while using our services;',
        'use all materials solely for your own personal and professional development.',
      ] },
      { t: 'h', x: '7. Community Standards' },
      { t: 'p', x: 'To maintain a positive learning environment, you agree not to:' },
      { t: 'ul', items: [
        'harass or intimidate others;',
        'engage in abusive, discriminatory, or offensive behaviour;',
        'disrupt live sessions;',
        'share another participant\'s confidential information;',
        'advertise products or services without permission;',
        'impersonate another individual;',
        'misuse the community platform.',
      ] },
      { t: 'p', x: 'We reserve the right to remove content or suspend participation where these standards are not respected.' },
      { t: 'h', x: '8. Intellectual Property' },
      { t: 'p', x: 'All content provided through LNG School remains the exclusive intellectual property of MZ Energy Solutions unless otherwise stated.' },
      { t: 'p', x: 'This includes, without limitation:' },
      { t: 'ul', items: [
        'videos;',
        'presentations;',
        'workbooks;',
        'templates;',
        'frameworks;',
        'simulator demonstrations;',
        'recordings;',
        'graphics;',
        'written materials;',
        'assessments;',
        'downloadable resources;',
        'branding;',
        'logos.',
      ] },
      { t: 'p', x: 'Your enrolment grants you a limited, personal, non-exclusive, non-transferable licence to access these materials for your own learning.' },
      { t: 'p', x: 'You may not:' },
      { t: 'ul', items: [
        'copy or reproduce program materials;',
        'record live sessions without written permission;',
        'distribute course content;',
        'upload materials to websites or social media;',
        'share login credentials;',
        'resell or sublicense program content;',
        'create competing educational products using LNG School materials;',
        'use artificial intelligence or automated systems to reproduce or redistribute substantial portions of our proprietary content.',
      ] },
      { t: 'h', x: '9. Educational Disclaimer' },
      { t: 'p', x: 'LNG School provides education, coaching, and career development services only.' },
      { t: 'p', x: 'Our programs are designed to improve technical knowledge, professional confidence, and career readiness.' },
      { t: 'p', x: 'Nothing provided by LNG School constitutes:' },
      { t: 'ul', items: [
        'legal advice;',
        'engineering advice;',
        'financial or tax advice;',
        'employment advice;',
        'regulatory certification;',
        'company-approved operating procedures.',
      ] },
      { t: 'p', x: 'Participants remain solely responsible for complying with their employer\'s policies, vessel Safety Management System (SMS), Flag State requirements, Classification Society requirements, terminal procedures, manufacturer guidance, and all applicable laws and regulations.' },
      { t: 'h', x: '10. Career Outcomes Disclaimer' },
      { t: 'p', x: 'While our objective is to help participants strengthen their knowledge, technical competence, interview performance, and career opportunities, LNG School cannot and does not guarantee:' },
      { t: 'ul', items: [
        'employment;',
        'interviews;',
        'promotions;',
        'salary increases;',
        'employment with a particular employer;',
        'visa approvals;',
        'licences or professional certifications;',
        'any specific career outcome.',
      ] },
      { t: 'p', x: 'Career progression depends upon numerous factors outside our control, including your qualifications, experience, effort, employer requirements, market conditions, immigration rules, and regulatory requirements.' },
      { t: 'h', x: '11. Refunds' },
      { t: 'p', x: 'We stand behind the quality of our educational programs and are committed to providing exceptional value to every participant.' },
      { t: 'p', x: 'If your program includes a satisfaction guarantee, the details of that guarantee will be stated on the applicable sales page and form part of these Terms.' },
      { t: 'p', x: 'To be eligible for a refund under any satisfaction guarantee, you must:' },
      { t: 'ul', items: [
        'complete the program requirements;',
        'actively participate in the program;',
        'complete any required assignments or activities;',
        'demonstrate a genuine effort to apply what you have learned;',
        'contact LNG School to request support before requesting a refund;',
        'submit your refund request within the timeframe specified for the applicable program.',
      ] },
      { t: 'p', x: 'Refunds will not normally be granted for:' },
      { t: 'ul', items: [
        'change of mind;',
        'personal scheduling conflicts;',
        'failure to attend sessions;',
        'failure to complete required activities;',
        'lack of time;',
        'technical issues outside LNG School\'s control;',
        'failure to review the program description before purchasing.',
      ] },
      { t: 'p', x: 'Where you purchase through an instalment plan, you remain responsible for the full program fee unless a refund is approved under this section.' },
      { t: 'p', x: 'Refund requests must be submitted in writing to support@lngschool.com.' },
      { t: 'p', x: 'We aim to review refund requests within ten (10) business days.' },
      { t: 'p', x: 'If a refund is approved, it will normally be processed to the original payment method. Upon completion of the refund, access to the applicable program and related resources may be removed.' },
      { t: 'p', x: 'Before initiating a chargeback with your payment provider, we encourage you to contact LNG School so that we can work in good faith to resolve your concerns.' },
      { t: 'h', x: '12. Privacy' },
      { t: 'p', x: 'Your use of LNG School is also governed by our Privacy Policy and Cookie Policy.' },
      { t: 'h', x: '13. Limitation of Liability' },
      { t: 'p', x: 'To the fullest extent permitted by applicable law, MZ Energy Solutions, LNG School, their directors, officers, employees, contractors, and representatives shall not be liable for any indirect, incidental, consequential, special, exemplary, or punitive damages arising from or related to your participation in any program or use of our website.' },
      { t: 'p', x: 'Without limiting the foregoing, we are not responsible for:' },
      { t: 'ul', items: [
        'employment decisions made by third parties;',
        'promotion decisions;',
        'visa or immigration outcomes;',
        'licensing or certification decisions;',
        'business losses;',
        'lost income or profits;',
        'interruption of internet services;',
        'failures of third-party platforms or service providers;',
        'technical issues beyond our reasonable control.',
      ] },
      { t: 'p', x: 'Our total liability for any claim arising from these Terms shall not exceed the amount you paid for the applicable program.' },
      { t: 'h', x: '14. Force Majeure' },
      { t: 'p', x: 'We shall not be liable for any delay or failure to perform our obligations resulting from events beyond our reasonable control, including natural disasters, pandemics, government actions, labour disputes, internet outages, cyberattacks, power failures, or failures of third-party platforms.' },
      { t: 'h', x: '15. Suspension and Termination' },
      { t: 'p', x: 'We may suspend or terminate your access to LNG School where you materially breach these Terms, violate our intellectual property rights, fail to make required payments, or engage in conduct that disrupts the learning environment.' },
      { t: 'p', x: 'Termination under this section does not automatically entitle you to a refund.' },
      { t: 'h', x: '16. Changes to These Terms' },
      { t: 'p', x: 'We may amend these Terms from time to time to reflect changes in our programs, legal obligations, or business operations.' },
      { t: 'p', x: 'The latest version will always be published on the LNG School website.' },
      { t: 'p', x: 'Continued use of our services after updated Terms are published constitutes acceptance of those changes.' },
      { t: 'h', x: '17. Governing Law' },
      { t: 'p', x: 'These Terms shall be governed by and interpreted in accordance with the laws of the Province of Ontario and the applicable federal laws of Canada.' },
      { t: 'p', x: 'Any dispute arising from these Terms shall be subject to the exclusive jurisdiction of the courts of Ontario, Canada, except where mandatory consumer protection laws provide otherwise.' },
      { t: 'h', x: '18. Contact Us' },
      { t: 'p', x: 'MZ Energy Solutions' },
      { t: 'p', x: 'Operating as LNG School' },
      { t: 'p', x: 'Ontario, Canada' },
      { t: 'p', x: 'Email: support@lngschool.com' },
      { t: 'p', x: 'Website: www.lngschool.com' },
      { t: 'p', x: 'By enrolling in any LNG School program or using our website, you acknowledge that you have read, understood, and agree to these Terms & Conditions.' },
    ],
  },
  {
    id: 'privacy',
    label: 'Privacy Policy',
    blocks: [
      { t: 'p', x: 'Effective Date: 27 July 2026' },
      { t: 'p', x: 'Operator: MZ Energy Solutions, Ontario, Canada' },
      { t: 'p', x: 'LNG School is the educational platform owned and operated by MZ Energy Solutions ("LNG School", "we", "our", or "us").' },
      { t: 'p', x: 'This Privacy Policy describes how we collect, use, disclose, store, and protect your personal information when you visit our website, enrol in our programs, purchase our services, or otherwise interact with LNG School.' },
      { t: 'p', x: 'By using our website or services, you agree to the collection and use of your information in accordance with this Privacy Policy.' },
      { t: 'h', x: '1. Who We Are' },
      { t: 'p', x: 'MZ Energy Solutions is a business registered in the Province of Ontario, Canada and operates LNG School as its educational platform for professional development within the liquefied natural gas (LNG) industry.' },
      { t: 'p', x: 'If you have any questions regarding this Privacy Policy or our handling of your personal information, please contact us using the details provided at the end of this Policy.' },
      { t: 'h', x: '2. Information We Collect' },
      { t: 'p', x: 'We may collect personal information that you voluntarily provide, including:' },
      { t: 'ul', items: [
        'Full name',
        'Email address',
        'Telephone number',
        'Country of residence',
        'Employer and job title (where provided)',
        'Billing information',
        'Payment information processed through our payment providers',
        'Course enrolment information',
        'Communications with our team',
        'Survey responses',
        'Student assignments and submissions',
        'Any other information you choose to provide.',
      ] },
      { t: 'p', x: 'We may also automatically collect certain technical information, including:' },
      { t: 'ul', items: [
        'IP address',
        'Browser type',
        'Device information',
        'Operating system',
        'Website usage data',
        'Pages visited',
        'Referral sources',
        'Cookie and analytics information.',
      ] },
      { t: 'h', x: '3. How We Collect Your Information' },
      { t: 'p', x: 'We collect information when you:' },
      { t: 'ul', items: [
        'Visit our website',
        'Register for our newsletter',
        'Join a waiting list',
        'Complete an application or enrolment form',
        'Purchase a program or service',
        'Contact us by email or through our website',
        'Participate in coaching sessions or live training',
        'Complete surveys or feedback forms',
        'Interact with our website through cookies and similar technologies.',
      ] },
      { t: 'h', x: '4. How We Use Your Information' },
      { t: 'p', x: 'We use your personal information to:' },
      { t: 'ul', items: [
        'Deliver our educational programs and services',
        'Process enrolments and payments',
        'Create and manage your student account',
        'Provide customer support',
        'Communicate with you about your program',
        'Send newsletters and educational content',
        'Notify you about new programs, events, and services',
        'Improve our website, programs, and student experience',
        'Monitor website performance and security',
        'Prevent fraud and misuse',
        'Comply with legal and regulatory obligations',
        'Protect our legal rights and interests.',
      ] },
      { t: 'h', x: '5. Payment Information' },
      { t: 'p', x: 'Payments are securely processed through trusted third-party payment providers, including Stripe and PayPal.' },
      { t: 'p', x: 'LNG School does not store your complete credit card or payment card information on its own systems.' },
      { t: 'p', x: 'Payment information is processed in accordance with the privacy policies and security standards of our payment providers.' },
      { t: 'h', x: '6. Sharing Your Information' },
      { t: 'p', x: 'We do not sell your personal information.' },
      { t: 'p', x: 'We may share your information with trusted service providers who assist us in operating our business, including providers of:' },
      { t: 'ul', items: [
        'Payment processing',
        'Email communications',
        'Learning management systems',
        'Video conferencing',
        'Website hosting',
        'Cloud storage',
        'Analytics',
        'Customer support',
        'Security and fraud prevention',
      ] },
      { t: 'p', x: 'These providers are authorised to process personal information only as necessary to perform services on our behalf.' },
      { t: 'p', x: 'We may also disclose personal information where required by law or where necessary to protect our legal rights.' },
      { t: 'h', x: '7. Email Communications' },
      { t: 'p', x: 'If you subscribe to our newsletter, join our waiting list, or enrol in one of our programs, we may send you:' },
      { t: 'ul', items: [
        'Educational content',
        'Industry news',
        'Program updates',
        'Webinar invitations',
        'Marketing communications',
        'Administrative notices relating to your enrolment.',
      ] },
      { t: 'p', x: 'You may unsubscribe from marketing communications at any time using the unsubscribe link included in our emails.' },
      { t: 'p', x: 'Even if you unsubscribe from marketing emails, we may continue to send important service-related communications regarding your account or enrolment.' },
      { t: 'h', x: '8. Cookies and Similar Technologies' },
      { t: 'p', x: 'Our website uses cookies and similar technologies to improve functionality, personalise your experience, analyse website performance, and understand how visitors use our website.' },
      { t: 'p', x: 'For more information about our use of cookies, please refer to our Cookie Policy.' },
      { t: 'h', x: '9. International Data Transfers' },
      { t: 'p', x: 'LNG School operates from Canada and serves students worldwide.' },
      { t: 'p', x: 'Your personal information may be processed or stored in Canada or in other countries where our trusted service providers operate.' },
      { t: 'p', x: 'Where personal information is transferred internationally, we take reasonable steps to ensure that it receives an appropriate level of protection.' },
      { t: 'h', x: '10. Data Retention' },
      { t: 'p', x: 'We retain personal information only for as long as reasonably necessary to:' },
      { t: 'ul', items: [
        'Provide our programs and services',
        'Maintain student records',
        'Comply with legal obligations',
        'Resolve disputes',
        'Enforce our agreements',
        'Protect our legal rights.',
      ] },
      { t: 'p', x: 'When personal information is no longer required, it will be securely deleted or anonymised where appropriate.' },
      { t: 'h', x: '11. Data Security' },
      { t: 'p', x: 'We implement reasonable administrative, technical, and organisational safeguards designed to protect personal information against unauthorised access, disclosure, alteration, or destruction.' },
      { t: 'p', x: 'While we take appropriate security measures, no method of transmitting or storing information electronically can be guaranteed to be completely secure.' },
      { t: 'h', x: '12. Your Privacy Rights' },
      { t: 'p', x: 'Subject to applicable law, you may have the right to:' },
      { t: 'ul', items: [
        'Access your personal information',
        'Request correction of inaccurate information',
        'Request deletion of your personal information',
        'Withdraw your consent where applicable',
        'Request a copy of your personal information',
        'Object to certain processing activities',
        'Submit a complaint to the appropriate privacy authority.',
      ] },
      { t: 'p', x: 'We will respond to privacy requests within a reasonable period and in accordance with applicable laws.' },
      { t: 'h', x: '13. Children\'s Privacy' },
      { t: 'p', x: 'LNG School is intended for individuals who are at least 18 years of age.' },
      { t: 'p', x: 'We do not knowingly collect personal information from children.' },
      { t: 'p', x: 'If we become aware that personal information has been collected from a child without appropriate authorisation, we will take reasonable steps to delete that information.' },
      { t: 'h', x: '14. Third-Party Websites' },
      { t: 'p', x: 'Our website may contain links to third-party websites or services.' },
      { t: 'p', x: 'We are not responsible for the privacy practices, security, or content of those third-party websites.' },
      { t: 'p', x: 'We encourage you to review the privacy policies of any third-party websites you visit.' },
      { t: 'h', x: '15. Changes to This Privacy Policy' },
      { t: 'p', x: 'We may update this Privacy Policy from time to time to reflect changes in our business, technology, legal obligations, or operational practices.' },
      { t: 'p', x: 'The most current version will always be published on the LNG School website with the updated Effective Date.' },
      { t: 'p', x: 'Your continued use of our website or services following any updates constitutes acceptance of the revised Privacy Policy.' },
      { t: 'h', x: '16. Contact Us' },
      { t: 'p', x: 'If you have any questions regarding this Privacy Policy or wish to exercise your privacy rights, please contact us:' },
      { t: 'h', x: 'MZ Energy Solutions' },
      { t: 'p', x: 'Operating as LNG School' },
      { t: 'p', x: 'Ontario, Canada' },
      { t: 'p', x: 'Email: support@lngschool.com' },
      { t: 'p', x: 'Website: www.lngschool.com' },
    ],
  },
  {
    id: 'cookies',
    label: 'Cookie Policy',
    blocks: [
      { t: 'p', x: 'Effective Date: 27 July 2026' },
      { t: 'p', x: 'Operator: MZ Energy Solutions, Ontario, Canada' },
      { t: 'p', x: 'LNG School is the educational platform owned and operated by MZ Energy Solutions ("LNG School", "we", "our", or "us").' },
      { t: 'p', x: 'This Cookie Policy explains how we use cookies and similar technologies when you visit the LNG School website.' },
      { t: 'p', x: 'By continuing to use our website, you acknowledge that cookies and similar technologies may be used as described in this Cookie Policy.' },
      { t: 'h', x: '1. What Are Cookies?' },
      { t: 'p', x: 'Cookies are small text files that are placed on your computer, smartphone, or other device when you visit a website.' },
      { t: 'p', x: 'Cookies help websites recognise your device, remember your preferences, improve website functionality, analyse website performance, and provide a better browsing experience.' },
      { t: 'p', x: 'Some cookies are placed directly by LNG School, while others are placed by trusted third-party service providers.' },
      { t: 'h', x: '2. Why We Use Cookies' },
      { t: 'p', x: 'We use cookies and similar technologies to:' },
      { t: 'ul', items: [
        'Ensure the website functions properly',
        'Maintain website security',
        'Remember your preferences',
        'Improve website performance',
        'Understand how visitors use our website',
        'Measure the effectiveness of our content and marketing',
        'Deliver and improve our educational services',
        'Provide a more personalised user experience',
      ] },
      { t: 'h', x: '3. Types of Cookies We Use' },
      { t: 'h', x: 'Essential Cookies' },
      { t: 'p', x: 'These cookies are necessary for the operation of our website.' },
      { t: 'p', x: 'They enable core functionality such as page navigation, security, account access, payment processing, and form submissions.' },
      { t: 'p', x: 'The website cannot function properly without these cookies.' },
      { t: 'h', x: 'Functional Cookies' },
      { t: 'p', x: 'These cookies remember your preferences and settings, allowing us to provide a more personalised browsing experience.' },
      { t: 'p', x: 'Examples include remembering language preferences, saved settings, or previously entered information.' },
      { t: 'h', x: 'Analytics Cookies' },
      { t: 'p', x: 'Analytics cookies help us understand how visitors interact with our website.' },
      { t: 'p', x: 'They collect information such as:' },
      { t: 'ul', items: [
        'Pages visited',
        'Time spent on the website',
        'Navigation patterns',
        'Device and browser information',
        'General geographic location',
        'Website performance',
      ] },
      { t: 'p', x: 'This information helps us improve our website and educational services.' },
      { t: 'h', x: 'Marketing Cookies' },
      { t: 'p', x: 'Where applicable, marketing cookies help us measure the effectiveness of our advertising campaigns and provide more relevant content.' },
      { t: 'p', x: 'These cookies may be used by advertising partners to understand how visitors interact with our website and marketing campaigns.' },
      { t: 'h', x: '4. Third-Party Cookies' },
      { t: 'p', x: 'We may use trusted third-party service providers that place cookies or similar technologies on our website to deliver their services.' },
      { t: 'p', x: 'These providers may include services relating to:' },
      { t: 'ul', items: [
        'Website analytics',
        'Payment processing',
        'Email communications',
        'Learning management systems',
        'Video conferencing',
        'Embedded video content',
        'Website security',
        'Content delivery',
        'Advertising and marketing',
      ] },
      { t: 'p', x: 'Each third-party provider processes information in accordance with its own privacy policy.' },
      { t: 'h', x: '5. Managing Your Cookie Preferences' },
      { t: 'p', x: 'Most web browsers allow you to control, block, or delete cookies through your browser settings.' },
      { t: 'p', x: 'You may choose to:' },
      { t: 'ul', items: [
        'Accept all cookies',
        'Reject certain cookies',
        'Delete existing cookies',
        'Receive notifications before cookies are stored',
      ] },
      { t: 'p', x: 'Please note that disabling certain cookies may affect the functionality and performance of our website, and some features may no longer operate as intended.' },
      { t: 'h', x: '6. Changes to This Cookie Policy' },
      { t: 'p', x: 'We may update this Cookie Policy from time to time to reflect changes in our website, technology, legal requirements, or business operations.' },
      { t: 'p', x: 'The most recent version will always be available on the LNG School website with the updated Effective Date.' },
      { t: 'h', x: '7. Contact Us' },
      { t: 'p', x: 'If you have any questions about this Cookie Policy or our use of cookies, please contact us.' },
      { t: 'h', x: 'MZ Energy Solutions' },
      { t: 'p', x: 'Operating as LNG School' },
      { t: 'p', x: 'Ontario, Canada' },
      { t: 'p', x: 'Email: support@lngschool.com' },
      { t: 'p', x: 'Website: www.lngschool.com' },
    ],
  },
];
